export default {"src":"/_next/static/media/design.7f20f046.svg","height":256,"width":362,"blurWidth":0,"blurHeight":0};